// extracted by mini-css-extract-plugin
export default {"content":"styles_content__zbPB5","inputRow":"styles_inputRow__GDet4","form":"styles_form__kcrmU","row":"styles_row__1vVOi","mb":"styles_mb__1ataa","actions":"styles_actions__P11G9"};